import { render, staticRenderFns } from "./EtapaExtraFormulario.vue?vue&type=template&id=5ffd1538"
import script from "./EtapaExtraFormulario.vue?vue&type=script&lang=js"
export * from "./EtapaExtraFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports